import { render, staticRenderFns } from "./FormBaseAccount.vue?vue&type=template&id=d2c83e0c&scoped=true&"
import script from "./FormBaseAccount.vue?vue&type=script&lang=js&"
export * from "./FormBaseAccount.vue?vue&type=script&lang=js&"
import style0 from "./FormBaseAccount.vue?vue&type=style&index=0&id=d2c83e0c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c83e0c",
  null
  
)

export default component.exports